function e() {
  let t = 0;
  return () => ++t;
}
export {
  e as IdFactory
};
//# sourceMappingURL=index17.js.map
